import { render, staticRenderFns } from "./BancadaGenIA.vue?vue&type=template&id=325d0a54&scoped=true"
import script from "./BancadaGenIA.vue?vue&type=script&lang=js"
export * from "./BancadaGenIA.vue?vue&type=script&lang=js"
import style0 from "./BancadaGenIA.vue?vue&type=style&index=0&id=325d0a54&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../ChatGenial-hom-sync/client/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "325d0a54",
  null
  
)

export default component.exports